import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Autocomplete, Backdrop, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import { cfpBaseUrl } from '../../../network/urls';
import { documentExtensions, portalName } from '../../../utils/PortalName';
import { resolveDiscoCompanyCodeForBranding } from '../../../utils/adminCompany';
import {
  buildCustomerIdYupRule,
  isValidCustomerIdLength,
} from '../../../utils/customerIdValidation';
import "../../GeneralServices/NewConnection/NewConnectionForm.scss";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import FormSubmissionSuccessDialog from '../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog';
import JsBarcode from "jsbarcode";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Error from '../../../components/error/error';
import mepcologo from "../../../images/mepcoLogo.png";
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import { companyShortName, dBillAPI, getPermissions, getRelevantCFCCode, handleFileUpload, numberFormatting, subDivAPI, subdivisionName } from '../../../services/Functions';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';

const CourtOrdersForm = () => {
  const initialValues = {
    // Classification group Initial Values
    iv_consumer_id: '',
    iv_reference_number: '',
    iv_circle: '',
    iv_division: '',
    iv_sub_divison: '',
    iv_address: '',
    // Installment Details field
    iv_bill_month: '',
    iv_order_type: 'C',
    iv_court_order_no: '',
    iv_court_order_date: '',
    iv_court_order_authority_name: '',
    iv_court_order_image: '',
    // Applicant Details group Initial Values
    iv_applicant_name: '',
    iv_applicant_cnic: '',
    iv_applicant_phone_no: '',
    iv_applicant_email: '',
    // Required Documents Initial Values
    iv_court_order_image: null,
    iv_connection_type: '',
    iv_tariff_description: '',
    iv_tariff_code: '',
    iv_cc_code: '',
    iv_previous_deferred_amount: 0,
    iv_newly_set_aside_amount: 0,
    iv_withdrawal_set_aside_amount: 0,
    iv_net_bill: '',
    iv_setAsideOrWithdrawFlag: '1', // 1 for setaside and 2 for withdrawal
  }
  // Classification Group States
  const [referenceNumber, setReferenceNumber] = useState('');
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [applicationId, setApplicationId] = useState();
  const [courtOrderPopup, setCourtOrderPopup] = useState(false);
  const navigate = useNavigate();
  const [searchBy, setSearchBy] = useState('referenceNo');
  // Documents states
  const [courtOrderImage, setCourtOrderDocument] = useState('');
  const [courtOrderImageError, setCourtOrderDocumentError] = useState('');
  // Thumbnail states
  const [courtOrderImageThumbnail, setCourtOrderDocumentThumbnail] = useState(null);
  // States for hiding conditional fields
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [customerId, setCustomerId] = useState('');
  const [error, setError] = useState();
  const [unpaidDebt, setUnpaidDebt] = useState(null);
  const [billMonth, setBillMonth] = useState('');
  const [tariff, setTariff] = useState('');
  const [ccCode, setCcCode] = useState('');
  const [courtOrdersArray, setCourtOrdersArray] = useState([])
  const [minDownPayment, setMinDownPayment] = useState(0);
  const [maxBillAmount, setMaxBillAmount] = useState(0);
  const [courtOrdersAlreadyCheck, setCourtOrdersAlreadyCheck] = useState(false)
  const [courtOrdersProvisions, setInstallmentProvisions] = useState();

  const { token, code: userCode, userId, cfcLevelId, roleId, selectedAdminCompanyCode } = useSelector((state) => state.auth)
  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );
  let userCompany = resolveDiscoCompanyCodeForBranding(
    userCode,
    roleId,
    selectedAdminCompanyCode,
  );
 const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const errorCloses = () => {
    setError('')
  }

  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle('')
    setDefaultDivision('')
    setError('')
    setSubDivision('')
    values.iv_address = ''
    values.iv_circle = ''
    values.iv_division = ''
    values.iv_sub_divison = ''
    values.iv_consumer_id = ''
    values.iv_reference_number = ''
    values.iv_previous_deferred_amount = 0
    values.iv_order_type = 'C'
    values.iv_court_order_no = ''
    values.iv_court_order_date = ''
    values.iv_court_order_authority_name = ''
    values.iv_newly_set_aside_amount = 0
    values.iv_withdrawal_set_aside_amount = 0
    values.iv_net_bill = ''
    values.iv_applicant_name = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_court_order_image = null
    values.iv_connection_type = ''
    values.iv_tariff_description = ''
    values.iv_tariff_code = ''
    resetForm()
    setCourtOrderDocument()
    setCourtOrderDocumentThumbnail()
    setReferenceNumber('');
    setBillMonth('')
    setTariff('')
    setCcCode('')
  };

  const referedToCFCLevelId = (totalBillAmount, noOfCourtOrders) => {
    if (courtOrdersProvisions) {
      let referedToCFCLevelId = 0;
      let instProvAccToNos = courtOrdersProvisions.filter((item) => item.noOfActions == noOfCourtOrders)
      let instProvAccToBillAmount = instProvAccToNos.find((item) => (item.amountFrom <= totalBillAmount) && (item.amountTo >= totalBillAmount))
      if (instProvAccToBillAmount.cfcLevelId) {
        referedToCFCLevelId = instProvAccToBillAmount.cfcLevelId
      }
      return referedToCFCLevelId
    }
  }

  const getFinalCFCLevelId = (initialReferedToCFCId, loggedInUserCFCId) => {
    if (initialReferedToCFCId && loggedInUserCFCId) {
      if (initialReferedToCFCId == loggedInUserCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId > initialReferedToCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId < initialReferedToCFCId) {
        return loggedInUserCFCId
      }
    }
  }

  const getOfficeCode = (referedToCFCLevelId, referenceNo) => {
    let officeCode = ''
    if (referedToCFCLevelId == 2) {
      officeCode = referenceNo.slice(2, 4)
    } else if (referedToCFCLevelId == 3) {
      officeCode = referenceNo.slice(2, 5)
    } else if (referedToCFCLevelId == 4) {
      officeCode = referenceNo.slice(2, 6)
    } else if (referedToCFCLevelId == 5) {
      officeCode = referenceNo.slice(2, 7)
    }
    return officeCode
  }

  const getRelevantCFCId = async (totalBill, noOfInst, referenceNo) => {
    if (courtOrdersProvisions) {
      let referedToCFCId = ''
      let initialReferedToCFCId = referedToCFCLevelId(totalBill, noOfInst)
      if (!(initialReferedToCFCId == parseInt(cfcLevelId))) {
        let referedToCFCLevelId = getFinalCFCLevelId(initialReferedToCFCId, parseInt(cfcLevelId))
        let officeCode = getOfficeCode(referedToCFCLevelId, referenceNo)
        referedToCFCId = await getRelevantCFCCode(token, officeCode, referedToCFCLevelId)
      } else {
        referedToCFCId = userCode
      }
      return referedToCFCId
    }
  }

  // Formik form submission and new connection API calling
  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm } = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      // Classification group Validations
      iv_reference_number: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'referenceNo',
        then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
        otherwise: Yup.string().optional()
      }),
      iv_consumer_id: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'consumerId',
        then: buildCustomerIdYupRule(userCompany),
        otherwise: Yup.string().optional()
      }),
      iv_circle: Yup.mixed().required("Please select a circle."),
      iv_division: Yup.mixed().required("Please select a division."),
      iv_sub_divison: Yup.mixed().required("Please select a sub division."),
      iv_court_order_no: Yup.string().required('Enter Court Order No.'),
      iv_court_order_date: Yup.string().required('Select Order Date.'),
      iv_order_type: Yup.mixed().required('Select order type.'),
      iv_court_order_authority_name: Yup.string().required('Enter Court Order Authority Name.'),
      iv_court_order_image: Yup.mixed().required('Upload Court Order Image.'),
      iv_net_bill: Yup.string().required('Total bill is required.'),
      iv_previous_deferred_amount: Yup.string().optional(),
      iv_newly_set_aside_amount: Yup.number().when(['iv_setAsideOrWithdrawFlag', 'iv_net_bill'],
        (iv_setAsideOrWithdrawFlag, iv_net_bill, schema) => {
          if (iv_setAsideOrWithdrawFlag == 1) {
            return schema
              .typeError('Set aside amount should be a number.')
              .min(1, "Amount can't be less than 1.")
              .max(iv_net_bill ? parseInt(iv_net_bill.replace(/,/g, '')) : 0, `Amount can't exceed net bill amount.`)
              .required('Enter Set aside Amount.');
          } else {
            return schema.optional();
          }
        }),
      iv_withdrawal_set_aside_amount: Yup.number()
        .when(['iv_setAsideOrWithdrawFlag', 'iv_previous_deferred_amount'], (iv_setAsideOrWithdrawFlag, iv_previous_deferred_amount, schema) => {
          if (iv_setAsideOrWithdrawFlag == 2) {
            if (parseInt(iv_previous_deferred_amount.replace(/,/g, '')) > 0) {
              return schema
                .typeError('Withdrawal amount should be a number.')
                .min(1, "Amount can't be less than 1.")
                .max(parseInt(iv_previous_deferred_amount.replace(/,/g, '')), `Amount can't exceed previous deferred amount.`)
                .required('Enter Withdrawal Amount.');
            } else {
              return schema.optional();
            }
          }
        }),
      iv_applicant_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.").min(11, "Please enter 11 digit phone number.").optional("Please enter valid mobile number.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
      iv_setAsideOrWithdrawFlag: Yup.mixed().required('Set Aside or Withdrawal flag is required!')
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true)

      // let referedToCFCId = await getRelevantCFCId(totalBill, values.iv_no_of_months, referenceNumber)

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      var formdata = new FormData();
      formdata.append("createdBy", userId);
      formdata.append("cfcId", userCode);
      formdata.append("isOnline", 1);
      formdata.append("submittedThrough", portalName);
      formdata.append("subDivisionCode", subDivision.code);
      formdata.append("divisionCode", defaultDivision.code);
      formdata.append("circleCode", defaultCircle.code);
      formdata.append("companyCode", parseInt(defaultCircle.code.toString().slice(0, 2)));
      formdata.append("applicationProgressId", "0");
      formdata.append("refNo", referenceNumber);
      formdata.append("name", values.iv_applicant_name);
      formdata.append("cnic", values.iv_applicant_cnic);
      formdata.append("phoneNo", values.iv_applicant_phone_no);
      formdata.append("courtOrderNo", values.iv_court_order_no);
      formdata.append("courtOrderDate", values.iv_court_order_date);
      formdata.append("courtOrderBy", values.iv_court_order_authority_name);
      formdata.append("deferredAmount", values.iv_previous_deferred_amount ? values.iv_previous_deferred_amount.replace(/,/g, '') : 0);
      formdata.append("withdrawalSetAsideAmount", values.iv_withdrawal_set_aside_amount ? values.iv_withdrawal_set_aside_amount : 0);
      formdata.append("courtOrderImg", courtOrderImageThumbnail);
      formdata.append("setAsideAmount", values.iv_newly_set_aside_amount ? values.iv_newly_set_aside_amount : 0);
      formdata.append("CustomerId", customerId);
      formdata.append("BillMonth", values.iv_bill_month)
      formdata.append("BillMonthTotalAmount", values.iv_net_bill.replace(/,/g, ''))
      formdata.append("tariffCode", values.iv_tariff_code)
      formdata.append("ccCode", values.iv_cc_code)
      formdata.append("tariffDesc", values.iv_tariff_description)
      formdata.append("adjType", values.iv_order_type);
      formdata.append("termAndConditionFlag", "yes");
      formdata.append("setAsideOrWithdrawFlag", values.iv_setAsideOrWithdrawFlag)

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "CourtOrder/CourtOrderInsert", requestOptions)
        .then(response => {
          if (response.status === 200) {
            return response.json();
          } else {
            setError("Failed to save court order data.");
          }
        })
        .then(result => {
          if (result.status === '200') {
            let applicationID = ''
            if (result.applicationNo) {
              applicationID = result.applicationNo
            }
            setApplicationId(applicationID)
            setCourtOrderPopup(true)
            printApplicationReceipt(values, applicationID, userId, referenceNumber);
            resetForm()
            setDefaultCircle()
            setDefaultDivision()
            setSubDivision()
          }
          else {
            setError(result.message)
          }
        })
        .catch(() => {});
      setViewBackdrop(false)
    }
  })

  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(userCompany, cfpBaseUrl, token)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  useEffect(() => {
    const getProvisions = async () => {
      let provisions = await getPermissions(token);
      setInstallmentProvisions(provisions)
    }
    getProvisions()
  }, [])

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter(division => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(d => d.code === division.divisionCode);
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(subDivision => subDivision.divisionCode === defaultDivision.code)
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(s => s.code === subDivision.subDivisionCode);
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);


  // Calling Billing API to fetch near by details
  useEffect(() => {
    if (referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(item => item.code === parseInt(circleCode));

      if (!circleObject) {
        // Handle circle not found
        setError(`Circle not found with code: ${circleCode}`);
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode));

      if (!defDivision) {
        // Handle division not found
        setError(`Division not found with code: ${divisionCode}. Contact Admin!`);
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode));
      if (!subDivisionObject) {
        // Handle subdivision not found
        setError(`Subdivision not found with code: ${subDivisionCode}`);
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);

  useEffect(() => {
    if (isValidCustomerIdLength(values.iv_consumer_id, userCompany)) {
      referenceApi();
    } else {
      setDefaultCircle('')
      setDefaultDivision('')
      setError('')
      setSubDivision('')
      values.iv_address = ''
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_reference_number = ''
      values.iv_applicant_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_court_order_no = ''
      values.iv_order_type = 'C'
      values.iv_court_order_date = ''
      values.iv_court_order_authority_name = ''
      values.iv_court_order_image = null
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      values.iv_bill_month = ''
      values.iv_cc_code = ''
      setCourtOrderDocument()
      setCourtOrderDocumentThumbnail()
      setReferenceNumber('')
    }
  }, [values.iv_consumer_id])

  useEffect(() => {
    if (values.iv_reference_number.length === 14) {
      referenceApi();
    } else {
      setDefaultCircle('')
      setDefaultDivision('')
      setError('')
      setSubDivision('')
      values.iv_address = ''
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_consumer_id = ''
      values.iv_applicant_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_order_type = 'C'
      values.iv_court_order_no = ''
      values.iv_court_order_date = ''
      values.iv_court_order_authority_name = ''
      values.iv_court_order_image = null
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      values.iv_bill_month = ''
      values.iv_cc_code = ''
      setCourtOrderDocument()
      setCourtOrderDocumentThumbnail()
      setReferenceNumber('')
    }
  }, [values.iv_reference_number])

  // Function to fetch sub division and near by name and address through API 
  const referenceApi = async () => {
    if (searchBy === 'consumerId') {
      setViewBackdrop(true)
      if (!values.iv_consumer_id) return;
      let apiResponse = await dBillAPI(token, values.iv_consumer_id)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        values.iv_previous_deferred_amount = numberFormatting(basicInfo.deffered_amnt ? basicInfo.deffered_amnt : 0)
        values.iv_net_bill = numberFormatting(parseInt(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : 0));
        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_bill_month = basicInfo.billMonth
        values.iv_cc_code = basicInfo.cc_code ? basicInfo.cc_code : "1501"
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setCustomerId(basicInfo.appNo)
      } else if (apiResponse.status == false) {
        setError('No Data Found against this Customer ID')
        errors.iv_consumer_id = 'No Data Found against this Customer ID.'
      }else {
        setError('Customer ID. not found!')
        errors.iv_consumer_id = 'Customer ID. not found!'
      }
      setViewBackdrop(false)
    }
    if (searchBy === 'referenceNo') {
      setViewBackdrop(true)
      if (!values.iv_reference_number) return;
      let apiResponse = await dBillAPI(token, values.iv_reference_number)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        values.iv_previous_deferred_amount = numberFormatting(basicInfo.deffered_amnt ? basicInfo.deffered_amnt : 0)
        values.iv_net_bill = numberFormatting(parseInt(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : 0));
        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_bill_month = basicInfo.billMonth
        values.iv_cc_code = basicInfo.cc_code ? basicInfo.cc_code : "1501"
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setCustomerId(basicInfo.appNo)
      }else if (apiResponse.status == false) {
        setError('No Data Found against this Reference No.')
           errors.iv_reference_number = 'No Data Found against this Reference No.'
      } else {
        setError('Reference No. not found!')
        errors.iv_reference_number = 'Reference No. not found!'
      }
      setViewBackdrop(false)
    }
  };

  //Function to set states of documents
  const CourtOrderDocument = (event) => {
    if (event.target.files) {
      const newFileName = 'copyOfApplicantCNIC.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, handleChange, setCourtOrderDocument, setCourtOrderDocumentError, setCourtOrderDocumentThumbnail, newFileName);
    }
  }

  const printApplicationReceipt = (values, applicationID, userId, referenceNo) => {
    const doc = new jsPDF({ compressPdf: true });
    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(mepcologo, "PNG", 90, height, 30, 10); // Adjust the position and size of the barcode image

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Installment Request",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height
    );
    doc.text(
      values.iv_sub_divison.toString() +
      " / " +
      subdivisionName(values.iv_sub_divison, subDivisionsArray),
      // 'Sub Division Name',
      padding + leftMargin,
      height
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNo, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");



    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userId, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(userCompany),
        "PNG",
        0,
        0,
        doc.internal.pageSize.getWidth(),
        doc.internal.pageSize.getHeight()
      );
    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, '_blank');

  };

  const handleClose = () => {
    setCourtOrderPopup(false);
    navigate('/set-aside-table')
  };

  const [courtOrdersStatusBarArray, setCourtOrdersStatusBarArray] = useState([{
    title1: 'APPLICATION',
    title2: 'DETAIL',
    status: 0
  },
  {
    title1: `APPLICANT's`,
    title2: 'CNIC',
    status: 0
  }]);

  return (
    <>
      <Grid container className='nC'>
        <Box className='nCContainer'>
          <div className="headingBarDiv">
            <h3 className="heading" style={{ backgroundColor: '#D81D24', color: 'white', width: '100%', padding: '10px', fontSize: '25px', paddingLeft: '40px' }}>
              Set Aside / Withdrawal
            </h3>
          </div>
          <form className='ncform'>
            <Typography variant="h6" className="groupTitle">
              <div className="redCell">
              </div>
              Applicant's Detail
            </Typography>
            <CustomerInformationCard
              searchBy={searchBy}
              SearchBy={SearchBy}
              errors={errors}
              values={values}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              defaultCircle={defaultCircle}
              circleList={circleList}
              setDefaultCircle={setDefaultCircle}
              defaultDivision={defaultDivision}
              divisionList={divisionList}
              setDefaultDivision={setDefaultDivision}
              subDivision={subDivision}
              subDivisionList={subDivisionList}
              setSubDivision={setSubDivision}
            />
            {/* <Grid container className='container'>
              <Grid item xs={3}>
                <Typography className="fieldLabel"> Search By</Typography>
                <FormControl className="form-control"  >
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_search_by"
                    defaultValue={searchBy}
                    value={searchBy}
                    onChange={SearchBy}
                  >
                    <FormControlLabel
                      value="referenceNo"
                      className="form-control-label"
                      control={<Radio />}
                      label="Reference No."
                      name="referenceNo"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="consumerId"
                      className="form-control-label"
                      control={<Radio />}
                      label="Customer ID."
                      name="consumerId"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {
                searchBy === 'consumerId' &&
                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Customer ID.</Typography>
                  <TextField
                    type='text'
                    name="iv_consumer_id"
                    autoComplete='off'
                    value={values.iv_consumer_id}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{ maxLength: 10 }}
                    id="iv_consumer_id"
                    className='textInputField'
                  />
                  <Box className='from-Error'>
                    {errors.iv_consumer_id && touched.iv_consumer_id ? (errors.iv_consumer_id) : null}
                  </Box>
                </Grid>
              }
              {
                searchBy === 'referenceNo' &&
                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Reference No.</Typography>
                  <TextField
                    type='text'
                    name="iv_reference_number"
                    autoComplete='off'
                    value={values.iv_reference_number}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{ maxLength: 14 }}
                    id="iv_reference_number"
                    className='textInputField'
                  />
                  <Box className='from-Error'>
                    {errors.iv_reference_number && touched.iv_reference_number ? (errors.iv_reference_number) : null}
                  </Box>
                </Grid>
              }
              <Grid item xs={3} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Name</Typography>
                <TextField
                  required
                  type='text'
                  name="iv_applicant_name"
                  value={values.iv_applicant_name}
                  autoComplete='off'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled
                  id="iv_applicant_name"
                  className='textInputField1'
                />
                <Box className='from-Error'>
                  {errors.iv_applicant_name && touched.iv_applicant_name ? (errors.iv_applicant_name) : null}
                </Box>
              </Grid>
              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>NIC. / CNIC. / NICOP.</Typography>
                <TextField
                  required
                  type='text'
                  name="iv_applicant_cnic"
                  disabled
                  value={values.iv_applicant_cnic}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_applicant_cnic"
                  className='textInputField1'
                />
                <Box className='from-Error'>
                  {errors.iv_applicant_cnic && touched.iv_applicant_cnic ? (errors.iv_applicant_cnic) : null}
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Typography className='fieldLabel'  >Phone No.</Typography>
                <TextField
                  required
                  type='text'
                  name="iv_applicant_phone_no"
                  autoComplete='off'
                  value={values.iv_applicant_phone_no}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inputProps={{ maxLength: 11 }}
                  id="iv_applicant_phone_no"
                  className='textInputField'
                />
                <Box className='from-Error'>
                  {errors.iv_applicant_phone_no && touched.iv_applicant_phone_no ? (errors.iv_applicant_phone_no) : null}
                </Box>
              </Grid>
              <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Circle</Typography>
                <Autocomplete
                  id="iv_circle"
                  name="iv_circle"
                  disabled
                  sx={{
                    '& .MuiAutocomplete-endAdornment': {
                      display: 'none', // Hides the down arrow
                    },
                  }}
                  value={defaultCircle ? defaultCircle : null}
                  options={circleList}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setDefaultCircle(value);
                      values.iv_circle = value.code
                    }
                  }}
                />
                <Box className='from-Error'>
                  {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                </Box>
              </Grid>
              <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Division</Typography>
                <Autocomplete
                  id="iv_division"
                  name="iv_division"
                  disabled
                  sx={{
                    '& .MuiAutocomplete-endAdornment': {
                      display: 'none', // Hides the down arrow
                    },
                  }}
                  options={divisionList}
                  value={defaultDivision ? defaultDivision : null}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setDefaultDivision(value);
                      values.iv_division = value.code
                    }
                  }}
                />
                <Box className='from-Error'>
                  {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                </Box>
              </Grid>
              <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Sub Division</Typography>
                <Autocomplete
                  id="iv_sub_divison"
                  value={subDivision ? subDivision : null}
                  name="iv_sub_divison"
                  disabled
                  sx={{
                    '& .MuiAutocomplete-endAdornment': {
                      display: 'none', // Hides the down arrow
                    },
                  }}
                  options={subDivisionList}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" className='textInputFieldAutoSelectDisabled' />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setSubDivision(value);
                      values.iv_sub_divison = value.code
                    }
                  }}
                />
                <Box className='from-Error'>
                  {errors.iv_sub_divison && touched.iv_sub_divison ? (errors.iv_sub_divison) : null}
                </Box>
              </Grid>
              <Grid item xs={4.5}>
                <Typography className='fieldLabel'>Address</Typography>
                <TextField name='iv_address'
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_address}
                  onChange={handleChange}
                  disabled
                  className='textInputFieldAddressing' />
              </Grid>
            </Grid> */}
            <Typography variant="h6" className="groupTitle">
              <div className="cyanCell">
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <div>
                  Order Detail
                </div>
                <FormControl className="form-control" sx={{ borderLeft: '1px solid grey', paddingLeft: '20px' }}>
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_setAsideOrWithdrawFlag"
                    defaultValue={values.iv_setAsideOrWithdrawFlag}
                    value={values.iv_setAsideOrWithdrawFlag}
                    onChange={(e) => {
                      handleChange(e);
                      values.iv_newly_set_aside_amount = 0
                      values.iv_newly_set_aside_amount = 0
                    }}
                  >
                    <FormControlLabel
                      value="1"
                      className="form-control-label"
                      control={<Radio />}
                      sx={{ '.MuiFormControlLabel-label': { fontSize: '14px' } }}
                      label="Set Aside"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="2"
                      className="form-control-label"
                      control={<Radio />}
                      sx={{ '.MuiFormControlLabel-label': { fontSize: '14px' } }}
                      label="Withdrawal"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Typography>
            <Grid container className='container' sx={{ marginTop: '10px' }}>
              <Grid item xs={2.5}>
                <Typography className="fieldLabel"> Type</Typography>
                <FormControl className="form-control">
                  <RadioGroup
                    className="radio-group"
                    row
                    name="iv_order_type"
                    defaultValue={values.iv_order_type}
                    value={values.iv_order_type}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="C"
                      className="form-control-label"
                      control={<Radio />}
                      sx={{ '.MuiFormControlLabel-label': { fontSize: '14px' } }}
                      label="Court"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="D"
                      className="form-control-label"
                      control={<Radio />}
                      sx={{ '.MuiFormControlLabel-label': { fontSize: '14px' } }}
                      label="Department"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
                <Box className="from-Error">
                  {errors.iv_order_type && touched.iv_order_type
                    ? errors.iv_order_type
                    : null}
                </Box>
              </Grid>
              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>{values.iv_order_type == "C" ? "Court" : "Dept."} Order No.</Typography>
                <TextField
                  required
                  type='text'
                  name="iv_court_order_no"
                  autoComplete='off'
                  value={values.iv_court_order_no}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inputProps={{ maxLength: 11 }}
                  id="iv_court_order_no"
                  className='textInputField'
                />
                <Box className='from-Error'>
                  {errors.iv_court_order_no && touched.iv_court_order_no ? (errors.iv_court_order_no) : null}
                </Box>
              </Grid>
              <Grid item xs={1} sx={{ paddingRight: '30px' }}>
                <Typography className='fieldLabel'>Dated</Typography>
                <input
                  required
                  type='date'
                  name="iv_court_order_date"
                  max={new Date().toISOString().split('T')[0]}
                  autoComplete='off'
                  value={values.iv_court_order_date}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_court_order_date"
                  className='textInputField'
                  style={{ padding: '7.5px', border: '1px solid lightgrey', borderRadius: '5px' }}
                />
                <Box className='from-Error'>
                  {errors.iv_court_order_date && touched.iv_court_order_date ? (errors.iv_court_order_date) : null}
                </Box>
              </Grid>
              <Grid item xs={2.5} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>By Order of</Typography>
                <TextField
                  required
                  type='text'
                  name="iv_court_order_authority_name"
                  autoComplete='off'
                  value={values.iv_court_order_authority_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_court_order_authority_name"
                  className='textInputField'
                />
                <Box className='from-Error'>
                  {errors.iv_court_order_authority_name && touched.iv_court_order_authority_name ? (errors.iv_court_order_authority_name) : null}
                </Box>
              </Grid>
              {
                values.iv_net_bill ?
                  <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                    <Typography className='fieldLabel'>Total Bill</Typography>
                    <TextField name="iv_net_bill"
                      required
                      type='text'
                      onBlur={handleBlur}
                      value={values.iv_net_bill}
                      disabled
                      className='textInputField1' />
                    <Box className='from-Error'>
                      {errors.iv_net_bill && touched.iv_net_bill ? (errors.iv_net_bill) : null}
                    </Box>
                  </Grid> : <></>
              }
              {
                values.iv_previous_deferred_amount ?
                  <Grid item xs={1.25} sx={{ paddingRight: '20px', marginTop: '-20px' }}>
                    <Typography className='fieldLabel'>Already Deferred Amount</Typography>
                    <TextField name="iv_previous_deferred_amount"
                      required
                      type='text'
                      onBlur={handleBlur}
                      value={values.iv_previous_deferred_amount}
                      disabled
                      className='textInputField1' />
                    <Box className='from-Error'>
                      {errors.iv_previous_deferred_amount && touched.iv_previous_deferred_amount ? (errors.iv_previous_deferred_amount) : null}
                    </Box>
                  </Grid> : <></>
              }
              {
                ((values.iv_setAsideOrWithdrawFlag == 1)) ?
                  <>
                    <Grid item xs={1.2} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Set Aside Amount</Typography>
                      <TextField
                        required
                        type='number'
                        name="iv_newly_set_aside_amount"
                        inputProps={{ min: 1 }}
                        autoComplete='off'
                        value={values.iv_newly_set_aside_amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        id="iv_newly_set_aside_amount"
                        className='textInputField'
                      />
                      <Box className='from-Error'>
                        {errors.iv_newly_set_aside_amount && touched.iv_newly_set_aside_amount ? (errors.iv_newly_set_aside_amount) : null}
                      </Box>
                    </Grid>
                    <Grid item xs={1.5} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Total Set Aside Amount</Typography>
                      <input
                        required
                        type='number'
                        name="iv_newly_set_aside_amount"
                        inputProps={{ min: 1 }}
                        disabled
                        autoComplete='off'
                        value={values.iv_previous_deferred_amount ? (values.iv_newly_set_aside_amount + parseInt(values.iv_previous_deferred_amount.replace(/,/g, ''))) : 0}
                        onChange={handleChange}
                        style={{ padding: '7px', borderRadius: '5px', border: 'none', color: 'white', backgroundColor: '#006ad1', fontSize: '18px', width: '70%' }}
                        onBlur={handleBlur}
                        id="iv_newly_set_aside_amount"
                        className='textInputField'
                      />
                    </Grid>
                  </>
                  : <></>
              }
              {
                (values.iv_setAsideOrWithdrawFlag == '2') ?
                  <>
                    <Grid item xs={1.2} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Withdrawal Amount</Typography>
                      <TextField
                        required
                        type='number'
                        name="iv_withdrawal_set_aside_amount"
                        autoComplete='off'
                        value={values.iv_withdrawal_set_aside_amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        // style={{ padding: '7px', borderRadius: '5px', border: 'none', color: 'white', backgroundColor: '#006ad1', fontSize: '18px' }}
                        id="iv_withdrawal_set_aside_amount"
                        className='textInputField'
                      />
                      <Box className='from-Error'>
                        {errors.iv_withdrawal_set_aside_amount && touched.iv_withdrawal_set_aside_amount ? (errors.iv_withdrawal_set_aside_amount) : null}
                      </Box>
                    </Grid>
                    <Grid item xs={1.5} sx={{ paddingRight: '20px' }}>
                      <Typography className='fieldLabel'>Total Set Aside Amount</Typography>
                      <input
                        required
                        type='number'
                        name="iv_newly_set_aside_amount"
                        inputProps={{ min: 1 }}
                        disabled
                        autoComplete='off'
                        value={values.iv_previous_deferred_amount ? (parseInt(values.iv_previous_deferred_amount.replace(/,/g, '')) - values.iv_withdrawal_set_aside_amount) : 0}
                        onChange={handleChange}
                        style={{ padding: '7px', borderRadius: '5px', border: 'none', color: 'white', backgroundColor: '#006ad1', fontSize: '18px', width: '70%' }}
                        onBlur={handleBlur}
                        id="iv_newly_set_aside_amount"
                        className='textInputField'
                      />
                    </Grid>
                  </>
                  : ''
              }
            </Grid>
            <Typography variant="h6" className="groupTitleDocuments">
              Required Documents
            </Typography>
            <Grid container className='document-container' >
              <Grid item lg={12}>
                <Grid container spacing={1} className='documentsContainer' sx={{ padding: '0px 30px' }}>
                  <Grid item lg={2} >
                    <Typography className='documentLabel' >1- Court Order Image</Typography>
                    <Typography sx={{ color: 'blue', fontSize: '12px', paddingLeft: '5px' }}>Multiple pages shall be grouped in the pdf.</Typography>
                    <Box className='documentError'>{errors.iv_court_order_image && touched.iv_court_order_image ? (errors.iv_court_order_image) : null} {courtOrderImageError && courtOrderImageError}</Box>
                  </Grid>
                  <Grid item lg={2}>
                    {
                      courtOrderImage ?
                        <>
                          <Button varient='outlined' component="label" startIcon={<DeleteOutlinedIcon sx={{ color: 'red' }} onClick={() => { setCourtOrderDocument('') }} />}  >
                            {courtOrderImageThumbnail && <img src={courtOrderImageThumbnail} alt="Applicant CNIC" width="100" />}
                          </Button>
                        </>
                        :
                        <>
                          <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />}  >
                            Upload
                            <input hidden accept={documentExtensions} id='iv_court_order_image' name='iv_court_order_image' type="file" onChange={CourtOrderDocument} />
                          </Button>
                        </>
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container >
              <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                {
                  error &&
                  <Error
                    error={error}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button className={((!isValidCustomerIdLength(values.iv_consumer_id, userCompany) || values.iv_reference_number.length != 14)
                // && values.iv_applicant_phone_no != ''
                && values.iv_court_order_no != ''
                && values.iv_court_order_date != ''
                && values.iv_court_order_authority_name != ''
                && values.iv_court_order_image != null
                && error == ''
              ) === false ? 'disabled-button' : 'button'}
                variant="contained" component="label" type='submit' onClick={handleSubmit} disabled={((!isValidCustomerIdLength(values.iv_consumer_id, userCompany) || values.iv_reference_number.length != 14)
                  // && values.iv_applicant_phone_no != ''
                  && values.iv_no_of_months != ''
                  && values.iv_court_order_no != ''
                  && values.iv_court_order_date != ''
                  && values.iv_court_order_authority_name != ''
                  && values.iv_court_order_image != null
                ) === false}>
                Submit
              </Button>
            </Box>
          </form >
        </Box >
      </Grid >

      <FormSubmissionSuccessDialog
        open={courtOrderPopup}
        onClose={handleClose}
        title="Request submitted"
        message="Your Court Order request is submitted successfully."
        trackingId={applicationId}
      />

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >

    </>
  );
}

export default CourtOrdersForm;